import React from "react";
import { Tag, Space, Tooltip } from "antd";

export const renderTags = (items, getColor) => {
  const cleanItems = (items || []).filter(Boolean);
  if (cleanItems.length === 0) return <span style={{ color: "#aaa" }}>-</span>;
  const [first, ...rest] = cleanItems;
  return (
    <Space size={[0, 4]} wrap>
      <Tag color={getColor(first)}>{first}</Tag>
      {rest.length > 0 && (
        <Tooltip
          title={
            <div
              style={{ display: "flex", flexDirection: "column", gap: "4px" }}
            >
              {rest.map((item, idx) => (
                <Tag color={getColor(item)} key={idx} style={{ margin: 0 }}>
                  {item}
                </Tag>
              ))}
            </div>
          }
          color="#fff"
          styles={{
            body: {
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #d9d9d9",
            },
          }}
        >
          <Tag style={{ cursor: "pointer", borderStyle: "dashed" }}>
            +{rest.length} more
          </Tag>
        </Tooltip>
      )}
    </Space>
  );
};
